import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import useDealer from '../../../hooks/useDealer/useDealer';
import { Accordion, Loading, Pagination } from '../../../components';
import { useWindowSize } from '../../../hooks';
import { LabelAndValue } from './Components/LabelAndValue';
import { Button, ButtonClean } from '../../../styles/lib/buttons';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import { useForm } from 'react-hook-form';
import { formatTimeStampToDate } from '../../../utils/functions';
import { InputContainer, PrimaryInput } from '../../../styles/lib/input';
import { FormSearch, ErroResponseArray, getStatusInfo } from './utils';
import { usePagination } from '../../../hooks/usePagination';
import * as S from './styles';

export const ActivityHistory: React.FC = () => {
  const {
    register,
    handleSubmit,
    reset,
    getValues,
    formState: { isSubmitted },
  } = useForm<FormSearch>({
    mode: 'onChange',
    defaultValues: {
      search: '',
    },
  });

  const { fetchDealerLogs, exportDealerLogs, isLoading, isLoadingExport } =
    useDealer();
  const [response, setResponse] = useState<ErroResponseArray>();

  const getLogs = async ({
    search,
    currentPage,
    pageSize,
  }: {
    search?: string;
    currentPage: number;
    pageSize: number;
  }) => {
    try {
      const data = await fetchDealerLogs({
        currentPage,
        pageSize,
        search,
      });
      if (data) {
        setResponse(data.data);
      }
    } catch (error) {
      toast.error('Falha ao carregar os logs.');
    }
  };
  const { currentPage, pageSize, handlePageChange, resetPagination } =
    usePagination({
      totalItems: response?.paginacao?.total || 0,
      onPageChange: (currentPage, pageSize) => {
        getLogs({
          currentPage,
          pageSize,
          search: getValues('search'),
        });
      },
    });

  const { isDesktop } = useWindowSize();

  useEffect(() => {
    getLogs({
      currentPage: 1,
      pageSize,
      search: '',
    });
  }, []);

  const handleExportLogs = (id: number) => {
    exportDealerLogs(id);
  };

  const onSubmit = async (data: FormSearch) => {
    resetPagination();
    await getLogs({
      currentPage: 1,
      pageSize,
      search: data?.search,
    });
  };

  return (
    <S.Wrapper>
      <S.Form onSubmit={handleSubmit(onSubmit)}>
        <S.GroupInputs>
          <InputContainer>
            <PrimaryInput
              {...register('search')}
              style={{ width: '100%' }}
              className="bg-white"
              type="text"
              placeholder="Pesquise por nome, método ou usuário."
            />
          </InputContainer>
          {/* <Select
              className="highlighted"
              {...register('perfis')}
              onChange={({ target }) => setValue('perfis', target.value)}
            >
              <Option value="">Todos Perfis</Option>
              {profileGroups
                .filter((group: IProfileGroup) => group.ativo)
                .map((group: IProfileGroup, index: number) => (
                  <Option key={index} value={group.nome}>
                    {group.nome}
                  </Option>
                ))}
            </Select>
            <InputDateStart
              type="date"
              min="2023-01-01"
              {...register('dateStart')}
              style={{ width: '140px' }}
            />

            <RadioButtonWrapper className="small horizontal">
              <label className="form-control">
                <input
                  type="radio"
                  value="todos"
                  {...register('options')}
                  checked={selectedValue === 'todos'}
                  onChange={() => setValue('options', 'todos')}
                />
                <span>Todos</span>
              </label>

              <label className="form-control">
                <input
                  type="radio"
                  value="sucesso"
                  {...register('options')}
                  checked={selectedValue === 'sucesso'}
                  onChange={() => setValue('options', 'sucesso')}
                />
                <span>Sucesso</span>
              </label>

              <label className="form-control">
                <input
                  type="radio"
                  value="erro"
                  {...register('options')}
                  checked={selectedValue === 'erro'}
                  onChange={() => setValue('options', 'erro')}
                />
                <span>Erro</span>
              </label>
            </RadioButtonWrapper> */}
        </S.GroupInputs>

        <S.ButtonGroups>
          <ButtonClean
            className="edit"
            type="button"
            style={{ width: '100px' }}
            onClick={() => reset()}
          >
            <IoIosCloseCircleOutline size={18} />
            Limpar tudo
          </ButtonClean>
          <Button
            type="submit"
            className="secondary"
            style={{
              width: '140px',
              height: '40px',
            }}
          >
            Buscar
          </Button>
        </S.ButtonGroups>
      </S.Form>

      {isSubmitted && !response?.logs && (
        <h6>Não foram encontrados logs de erro para a busca realizada</h6>
      )}

      {isLoading ? (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Loading />
        </div>
      ) : (
        <S.ListErrors>
          {response?.logs?.map((log, index) => {
            const { text, color } = getStatusInfo(log.status);
            const topContent = isDesktop
              ? [
                  {
                    label: 'Data / Hora',
                    value: formatTimeStampToDate(log.data || ''),
                  },
                  { label: 'Tipo de Ação', value: log.metodo },
                  { label: 'Status / Código', value: text, color },
                  { label: 'Administrador', value: log.nomeUsuarioAdmin },
                ]
              : [{ label: 'Status / Código', value: text, color }];

            const bottomContent = isDesktop
              ? [
                  { label: 'Usuário impactado', value: log.revendaImpactada },
                  { label: 'Perfil', value: log.descricaoPerfil },
                ]
              : [
                  {
                    label: 'Data / Hora',
                    value: formatTimeStampToDate(log.data || ''),
                  },
                  { label: 'Tipo de Ação', value: log.metodo },
                  { label: 'Administrador', value: log.nomeUsuarioAdmin },
                  { label: 'Usuário impactado', value: log.revendaImpactada },
                  { label: 'Perfil', value: log.descricaoPerfil },
                ];

            return (
              <Accordion
                id={`accordion-${index}`}
                key={index}
                triggerContent={
                  <S.AccordionContent
                    style={{ width: '100%', justifyContent: 'space-between' }}
                  >
                    {topContent.map(({ label, value }, index) => (
                      <LabelAndValue
                        key={index}
                        label={label}
                        value={value}
                        color={label === 'Status / Código' ? color : undefined}
                      />
                    ))}
                  </S.AccordionContent>
                }
                content={
                  <>
                    <S.AccordionContent>
                      {bottomContent.map(({ label, value }, index) => (
                        <LabelAndValue
                          key={index}
                          label={label}
                          value={value}
                        />
                      ))}
                    </S.AccordionContent>
                    {isDesktop ? (
                      <S.TechnicalDetails>
                        <S.Header>
                          <h4>Detalhes técnicos</h4>
                          <Button
                            type="submit"
                            className="secondary"
                            style={{ maxWidth: '140px', height: '40px' }}
                            disabled={isLoadingExport}
                            onClick={() => handleExportLogs(log.id)}
                          >
                            {isLoadingExport ? 'Exportando...' : 'Exportar log'}
                          </Button>
                        </S.Header>
                        <S.Separator />
                        <S.Content>
                          <span>
                            <strong>Descrição do erro:</strong>
                            <p>{log.erro}</p>
                          </span>
                        </S.Content>
                      </S.TechnicalDetails>
                    ) : (
                      <Button
                        type="submit"
                        className="secondary"
                        style={{
                          height: '40px',
                          marginTop: '16px',
                        }}
                        disabled={isLoadingExport}
                        onClick={() => handleExportLogs(log.id)}
                      >
                        {isLoadingExport ? 'Exportando...' : 'Exportar log'}
                      </Button>
                    )}
                  </>
                }
              />
            );
          })}
        </S.ListErrors>
      )}
      {!isLoading && response?.logs?.length !== 0 && (
        <Pagination
          currentPage={currentPage}
          paginationSize={pageSize}
          onPageChange={handlePageChange}
          totalItems={response?.paginacao?.total || 0}
        />
      )}
    </S.Wrapper>
  );
};
